import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientPageComponent } from './client-page/client-page.component';
import { ClientComponent } from './client.component';

const routes: Routes = [
  { path: '', component: ClientComponent, canActivate: [], children: [
    { path: '', component: ClientPageComponent},
    { path: 'service/:serviceId', component: ClientPageComponent},
    { path: ':providerOrStoreSlug', component: ClientPageComponent},
    { path: 'cancellation/:bookingId/:bookingCode', component: ClientPageComponent, data: { type: 'cancelBooking' }},
    { path: 'pay/:bookingId/:bookingCode', component: ClientPageComponent, data: { type: 'payBooking' }}
  ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientRoutingModule { }
